export function setupLoginModalListeners() {
    const loginModal = document.querySelector('#loginPopupCurtain');
    const loginModalOpenSelector = '[data-login-modal-open="true"]';
    const loginModalCloseSelector = '[data-login-modal-close="true"]';

    const loginModalOpen = document.querySelectorAll(loginModalOpenSelector);
    const loginModalClose = document.querySelectorAll(loginModalCloseSelector);

    loginModalOpen.forEach((element) => {
        element.addEventListener('click', () => {
            const type = element.getAttribute('data-login-modal-type') || 'login';
            openLoginModal(type);
        });
    });

    loginModalClose.forEach((element) => {
        element.addEventListener('click', () => {
            closeLoginModal();
        });
    });
}

export function closeAds(){
    const ads = document.querySelectorAll(`[id*='r89']`);
    ads.forEach((ad) => {
        (ad as HTMLElement).style.display = 'none';
    });

    const ads2 = document.querySelectorAll(`[class*='st-placement']`);
    ads2.forEach((ad) => {
        (ad as HTMLElement).style.display = 'none';
    });
}

export function openLoginModal(type = 'login') {
    const loginModal = document.querySelector('#loginPopupCurtain');
    if (!loginModal) return;
    const loginRadio = document.querySelector('#login-popup-radio-login');
    if (loginRadio) {
        (loginRadio as HTMLInputElement).checked = type == 'login';
    }
    const registerRadio = document.querySelector('#login-popup-radio-register');
    if (registerRadio) {
        (registerRadio as HTMLInputElement).checked = type == 'signup';
    }

    const forgotPasswordPopupCheckbox = document.querySelector('#forgot-password-popup-checkbox');
    if (forgotPasswordPopupCheckbox) {
        (forgotPasswordPopupCheckbox as HTMLInputElement).checked = false;
    }
    (loginModal as HTMLElement).style.display = 'block';
    document.body.classList.add('no-scroll');
    closeAds();
}

export function closeLoginModal() {
    document.body.classList.remove('no-scroll');
    const loginModal = document.querySelector('#loginPopupCurtain');
    if (!loginModal) return;
    (loginModal as HTMLElement).style.display = 'none';
}
